<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title" :class="type"></h5>
                    <div class="msg-view">
                        <p v-html=" text || text_mainfest[type] "></p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>                       
                    </div>                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.msg-modal{
    //width: 528px;
    // height: 308px;
    // background-image: url(~@/assets/images/modal/bg-modal-msg.png);     
}

.title{
    width: 100%;
    height: 55px;
    margin: 0 auto 30px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(~@/assets/images/modal/title-success.png); 
    
    &.success-apply{
        background-image: url(~@/assets/images/modal/title-apply_success.png);   
    }

    &.error-apply{
        background-image: url(~@/assets/images/modal/title-apply_error.png);   
    }    
  
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    /* width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e; */
}

.msg-view p{
    padding: 0 50px;
    line-height: 1.8;
    text-align: center;
    font-size: 24px;
    color: #686258;
    
    b{
        padding: 0 10px;
        color: #d16443;
    }
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
}

.u-ctrl .u-btn.ok{
    width: 266px;
    height: 69px;
    margin: 20px auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);     
}


</style>

<style lang="scss">
.msg-view p{    
    b{
        padding: 0 10px;
        color: #d16443;
    }
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : '',
            name : '',
            text_mainfest : {
                'success' : '奖励已发放至军师邮箱或网页活动，请及时领取',
                'success-apply' : '请耐心等待队长 在【申请列表】确认！',
                'error-apply' : '入队失败，请选择其他玩家结义',               
            },
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>